import { render, staticRenderFns } from "./TermometriaVisualizar.vue?vue&type=template&id=5974716a&scoped=true&"
import script from "./TermometriaVisualizar.vue?vue&type=script&lang=js&"
export * from "./TermometriaVisualizar.vue?vue&type=script&lang=js&"
import style0 from "./TermometriaVisualizar.vue?vue&type=style&index=0&id=5974716a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5974716a",
  null
  
)

export default component.exports